import React, { useRef } from 'react';
import FormCard from 'pages/NewUniProfile/components/FormCard';
import LicenseUploadForm from 'components/PPAOnboarding/LicenseUploadForm';
import LicenseImg from 'components/LicenseImg';
import commonS from '../../s.module.less';
import s from './s.module.less';
import { License } from 'types/common';
import dayjs from 'dayjs';

interface Props {
    initValue?: License[] | null;
    onSave?: () => void;
    isWarning?: boolean;
}

const MedicalLicenses: React.FC<Props> = (props) => {
    const { initValue, onSave, isWarning = false } = props;
    const licenseUploadFormRef = useRef<{ onUpdate:() => Promise<void> }>(null);

    const handleSave = async () => {
        try {
            await licenseUploadFormRef.current?.onUpdate();
            onSave?.();
        } catch (error) {
            console.error('Form save failed:', error);
            throw error;
        }
    };

    const renderEditing = () => {
        return (
            <div className={s.editingContainer}>
                <LicenseUploadForm ref={licenseUploadFormRef} value={initValue} />
            </div>
        );
    };

    const renderReview = () => {
        const hasData = initValue && initValue.length > 0;

        if (!hasData) {
            return (
                <div className={s.reviewContainer}>
                    <div className={s.licenseItem}>
                        <div className={s.licenseHeader}>
                            <h3 className={s.licenseTitle}>Licences 1</h3>
                        </div>

                        <div className={commonS.row}>
                            <div className={commonS.displayItem}>
                                <div className={commonS.label}>State for licenses</div>
                                <div className={commonS.value}>-</div>
                            </div>
                            <div className={commonS.displayItem}>
                                <div className={commonS.label}>License name</div>
                                <div className={commonS.value}>-</div>
                            </div>
                        </div>

                        <div className={commonS.row}>
                            <div className={commonS.displayItem}>
                                <div className={commonS.label}>License number</div>
                                <div className={commonS.value}>-</div>
                            </div>
                            <div className={commonS.displayItem}>
                                <div className={commonS.label}>Expiration date</div>
                                <div className={commonS.value}>-</div>
                            </div>
                        </div>

                        <div className={commonS.row}>
                            <div className={commonS.displayItem}>
                                <div className={commonS.label}>Upload the copy of the license</div>
                                <div className={commonS.value}>-</div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className={s.reviewContainer}>
                {initValue.map((license, index) => (
                    <div key={index} className={s.licenseItem}>
                        <div className={s.licenseHeader}>
                            <h3 className={s.licenseTitle}>Licences {index + 1}</h3>
                        </div>

                        <div className={commonS.row}>
                            <div className={commonS.displayItem}>
                                <div className={commonS.label}>State for licenses</div>
                                <div className={commonS.value}>{license.state || '-'}</div>
                            </div>
                            <div className={commonS.displayItem}>
                                <div className={commonS.label}>License name</div>
                                <div className={commonS.value}>{license.type || '-'}</div>
                            </div>
                        </div>

                        <div className={commonS.row}>
                            <div className={commonS.displayItem}>
                                <div className={commonS.label}>License number</div>
                                <div className={commonS.value}>{license.licenseNumber || '-'}</div>
                            </div>
                            <div className={commonS.displayItem}>
                                <div className={commonS.label}>Expiration date</div>
                                <div className={commonS.value}>{license.expireDate ? dayjs(license.expireDate).format('MM-DD-YYYY') : '-'}</div>
                            </div>
                        </div>

                        <div className={commonS.row}>
                            <div className={commonS.displayItem}>
                                <div className={commonS.label}>Uploaded licenses</div>
                                <div className={s.licenseImageContainer}>
                                    {license.fullUrl ? (
                                        <div className={s.licenseImageItem}>
                                            <LicenseImg src={license.fullUrl} />
                                        </div>
                                    ) : (
                                        <div className={commonS.value}>-</div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    return (
        <FormCard type="review" title="Medical licences" hasContent onSave={handleSave} isWarning={isWarning}>
            {(isEditing) => (isEditing ? renderEditing() : renderReview())}
        </FormCard>
    );
};

export default MedicalLicenses;
